import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

function Login() {

    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        const redirect = searchParams.get("redirect")
        axios.post('/api/user/exit')
            .then((res) => {

                return window.location.replace(redirect);
            })
    }, []);

    return (
        <>
            <div>ВЫХОД</div>
        </>
    );
}

export default Login;
